<template>
  <div
    class="d-lg-none">
    <!-- フッター -->
    <mobile-footer v-if="!hideFooter" />
  </div>
</template>

<script>
import MobileFooter from '@/components/parts/MobileFooter.vue'

export default {
  components: {
    MobileFooter,
  },
  computed: {
    hideFooter() {
      // 一部の画面でmobile-footerを非表示にする
      return [
        'goalAdd',
        'goalEdit',
        'activityResultAdd',
        'activityResultEdit',
        'eventAdd',
        'eventEdit',
      ].includes(this.$route.name)
    }
  }
}
</script>

<style>

</style>